import React from 'react';

const Footer = () => {
    return (
        <div className="p-5 mt-5 border-t dark:border-gray-700 border-gray-200 text-center">
            2021 Goggl, Inc.
        </div>
    )
};

export default Footer;
